/* globals sessionStorage */

/**
 * return product category in this format ex: marketing/14, tier/low-tier
 * @return {String}
 */
const getProductCategory = () => {
  const companyData = getCompanyData();

  return companyData.slug ? 'b2b' : 'b2c';
};

/**
 * return product category in this format ex: marketing/14, tier/low-tier
 * @param {String} membershipCategory
 * @return {String}
 */
const getMembershipType = membershipCategory => (membershipCategory === 'business_tier' ? 'b2b' : 'b2c');

/**
 * return product category in this format ex: marketing/14, tier/low-tier
 * @param {String} productCategory
 * @return {String}
 */
const getCheckoutFlow = productCategory => `${getProductCategory()} ${productCategory === 'marketing' ? 'free trial' : 'default'}`;

/**
 * Get product variant
 * @param {Object} product
 * @return {String}
 */
const getProductVariant = product => (product.price ? 'standard' : 'free_trial');

/**
 *
 * @param {Object} product
 * @return {Object}
 */
const mapProduct = (product, coupon) => ({
  item_id: product.uuid,
  item_name: `${product.period_amount} ${product.period_unit}`,
  item_variant: product.name.toLowerCase(),
  item_category: getProductCategory(),
  item_category2: getProductVariant(product),
  price: (product.price / 100).toFixed(2),
  quantity: 1,
  coupon,
});

/**
 * return discount id in case the order has a discount object,
 * otherwise return promo code if it exist, else empty string
 * @param {Object} order
 * @return {String}
 */
const getCoupon = order => (order.discount && order.discount.id) || (order.promo_code ? order.promo_code : '');

/**
 * check if a company slug saved in the session in case it's a business product, return it if so
 * @return {Object}
*/
const getCompanyData = () => {
  if (sessionStorage.getItem('companyData')) {
    return JSON.parse(sessionStorage.getItem('companyData'));
  }

  return {};
};

export {
  mapProduct,
  getCoupon,
  getMembershipType,
  getCheckoutFlow,
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/eventTracker/utils/index.js